export class AdjustZoom {
    constructor() {
        // ...
    }

    init() {
        const zoom = this.getZoomLevel();

        // console.log("zoom init");

        if (zoom > 100) {
            document.body.classList.add(`zoom-${zoom}`);
            // console.log(`Zoom detected: ${zoom}%`);
        }
    }
    getZoomLevel() {
        return Math.round((window.outerWidth / window.innerWidth) * 100);
    }
}
